






































































































































































































































































































































































import Vue from 'vue'
import FileSpace from './FileSpace'
import Modal from '@/components/Modal'
import { required, minLength } from 'vuelidate/lib/validators'
import { Select, Option } from 'element-ui'
import './FileExplorer.scss'
import { AssetGroupType, AssetGroup } from '@/types/assets'
import { Team } from '@/types/teams'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import AssetTypeModal from '@/components/FileExplorer/FileSpace/AssetTypeModal/AssetTypeModal.vue'
import FolderTree from '@/components/FileExplorer/FolderList/FolderTree/FolderTree.vue'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { Feature } from '@/featureFlags/featureFlags'
import { KeyDict } from '@/types'
import { pickBy } from 'lodash'

// Validator
// @ts-ignore
const inArray = (_matches = (e, v) => e === v) =>
  function (value: any, component: any): any {
    const sanitizedValue = value.toLowerCase()
    const activeFolder = component.activeFolder
    if (!activeFolder || !activeFolder.id) {
      // @ts-ignore
      const rootMatches = Object.values(this.rootFolders).filter((folder: AssetGroup) => {
        // @ts-ignore
        const hasSameType = this.newAssetGroupType === folder.type
        const hasSameName = folder.name.toLowerCase() === sanitizedValue
        return hasSameName && hasSameType
      })
      return rootMatches.length === 0
      // return true
    }

    // check in current folder
    // @ts-ignore
    const others = Object.values(this.folderList).filter((folder: AssetGroup) => {
      // @ts-ignore
      const hasSameType = this.newAssetGroupType === folder.type
      const hasSameName = folder.name.toLowerCase() === sanitizedValue
      const hasSameParent = folder.parent_id === activeFolder.id
      return hasSameName && hasSameType && hasSameParent
    })
    return others.length === 0
  }

// @ts-ignore
const correctUrl = (_matches = (e, v) => e === v) =>
  function (value: any): any {
    // @ts-ignore
    if (this.newAssetGroupType === AssetGroupType.TwitterPoll || this.newAssetGroupType === AssetGroupType.Tweet) {
      if (!value.startsWith('https://twitter.com/')) {
        return false
      }
      if (value.indexOf('/status/') === -1) {
        return false
      }
    }
    return true
  }

const cleanHashtag = (_matches = (e, v) => e === v) =>
  function (value: any): any {
    // @ts-ignore
    if (![AssetGroupType.TwitterHashtag, AssetGroupType.TwitterHandle, AssetGroupType.InstagramHashtag].includes(this.newAssetGroupType)) {
      return true
    }
    const blacklistChars = ' !?;\'"={}()#$%^&*[]|:.,`~@^+/\\'
    for (const char of blacklistChars) {
      if (value.indexOf(char) !== -1) {
        return false
      }
    }
    return true
  }

// @ts-ignore
const correctYTUrl = (_matches = (e, v) => e === v) =>
  function (value: any): any {
    // @ts-ignore
    if (this.newAssetGroupType !== AssetGroupType.YouTubeChat) {
      return true
    }
    if (!value.startsWith('https://www.youtube.com/watch?v=')) {
      return false
    }
    return true
  }

// @ts-ignore
const correctIGUrl = (_matches = (e, v) => e === v) =>
  function (value: any): any {
    // @ts-ignore
    if (this.newAssetGroupType === AssetGroupType.InstagramHashtag) {
      if (!value.startsWith('https://www.instagram.com/p/')) {
        return false
      }
    }
    return true
  }

export default Vue.extend({
  name: 'FileExplorer',
  props: {
    userId: {
      type: String
    },
    folders: {
      type: Object as () => KeyDict<AssetGroup>,
      required: true
    },
    teamId: {
      type: String
    },
    inCast: {
      type: Boolean,
      default: false
    },
    initializing: {
      type: Boolean,
      default: false
    },
    assetsLoading: {
      type: Boolean,
      default: false
    },
    updatesReady: {
      type: Boolean,
      default: false
    },
    // loadingAsset: {
    //   type: Boolean,
    //   default: false
    // },
    streamsManager: {
      type: Object
    },
    sourceStreams: {
      type: Object
    }
  },
  computed: {
    folderTreeVisible (): boolean {
      return !!this.folders && Object.keys(this.folders).length > 0
    },
    canAddAssetsToFolder (): boolean {
      return !this.isSocialMedia
    },
    isSubmitting (): boolean {
      return this.submitStatus === 'submitting'
    },
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
    rootFolders (): KeyDict<AssetGroup> {
      return pickBy(this.$store.direct.state.assets.folderList, folder => folder.parent_id === AssetGroupType.RootFolder)
    },
    allFolders (): KeyDict<AssetGroup> {
      return this.$store.direct.state.assets.folderList
    },
    canEditFolders (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.AssetGroups)
    },
    name (): string {
      // let name = this.teamName
      let name = 'All assets'
      if (this.activeFolder && this.activeFolder.name) {
        name = this.activeFolder.name

        const socialMediaType = this.socialMediaType
        const isChat = socialMediaType.indexOf('chat') > -1
        if (this.isSocialMedia && !isChat) {
          const prefix = (socialMediaType.indexOf('hashtag') > -1) ? '#' : '@'
          name = prefix + name
        }
      // deprecated in assets folder
      // } else if (this.isLiveStreamsFolder) {
      //   name = "Live streams"
      }
      return name
    },
    icon (): string {
      let icon = 'folder-open'

      const socialMediaType = this.socialMediaType
      if (socialMediaType) {
        switch (socialMediaType) {
          case AssetGroupType.TwitterHashtag:
          case AssetGroupType.TwitterHandle:
            icon = 'brands/twitter'
            break
          case AssetGroupType.InstagramHashtag:
          case AssetGroupType.InstagramHandle:
            icon = 'brands/instagram'
            break
          case AssetGroupType.YouTubeChat:
            icon = 'brands/youtube'
            break
        }
      }
      return icon
    },
    isSocialMedia (): boolean {
      const isSocialMedia = this.activeFolder && this.activeFolder.type && (this.activeFolder.type.indexOf('hashtag') > -1 || this.activeFolder.type.indexOf('handle') > -1 || this.activeFolder.type.indexOf('chat') > -1)
      return !!isSocialMedia
    },
    isTwitter (): boolean {
      return !!this.activeFolder && !!this.activeFolder.type && (this.activeFolder.type === AssetGroupType.TwitterHashtag || this.activeFolder.type === AssetGroupType.TwitterHandle)
    },
    isInstagram (): boolean {
      return !!this.activeFolder && !!this.activeFolder.type && this.activeFolder.type === AssetGroupType.InstagramHashtag
    },
    isLiveStreamsFolder (): boolean {
      // inCast only, deprecated since v2.12 (new "input streams" tab)
      return !this.activeFolder && this.selectedFolder === AssetGroupType.LiveStream
    },
    socialMediaType (): AssetGroupType {
      return (this.isSocialMedia && this.activeFolder && this.activeFolder.type) ? this.activeFolder.type : AssetGroupType.Unknown
    },
    alreadyExistsMessage (): string {
      switch (this.newAssetGroupType) {
        case AssetGroupType.Folder:
          let msg = 'Folder already exists'
          const isRoot = !this.activeFolder || !this.activeFolder.id
          if (isRoot === false) {
            msg += ' in this folder'
          }
          return msg
        case AssetGroupType.TwitterHashtag:
          return 'Hashtag already exists in this folder'
        case AssetGroupType.TwitterHandle:
          return 'Handle already exists in this folder'
        case AssetGroupType.TwitterPoll:
          return 'Poll name already exists in this folder'
        case AssetGroupType.InstagramHashtag:
          return 'Hashtag already exists in this folder'
        case AssetGroupType.YouTubeChat:
          return 'A Live video chat with this name already exists in this folder'
      }

      return ''
    },
    // legacy code returned string only, allow getting complete object (activeFolder/selectedFolder - might cause some confusion)
    activeFolder (): AssetGroup | undefined {
      return this.$store.direct.getters.assets.activeFolder || undefined
    },
    selectedFolder (): string {
      return this.$store.direct.state.assets.selectedFolder
    },
    folderList (): KeyDict<AssetGroup> {
      return this.$store.direct.state.assets.folderList
    },
    nestedFolders (): KeyDict<AssetGroup> {
      const isRoot = !this.activeFolder || !this.activeFolder.id
      if (isRoot || this.inCast && !this.selectedFolder) {
        // root level
        return this.folders
      }
      const subFolders = this.$store.direct.state.assets.subFolders
      return subFolders
    },
    team (): undefined | Team {
      return this.$store.direct.state.team.team
    },
    teamName (): string {
      if (this.team && !this.team.name) {
        return 'Loading'
      }

      return (this.team) ? this.team.name + ' Assets' : 'All assets'
    },
    allTeams (): undefined|Team[] {
      const singleTeam = !this.$store.direct.state.team.allTeams || !this.$store.direct.state.team.allTeams.length
      if (singleTeam && !!this.team) {
        return [this.$store.direct.state.team.team]
      }

      return this.$store.direct.state.team.allTeams
    },
    foldertype (): undefined|AssetGroupType {
      if (!this.folders) {
        return undefined
      }
      if (!this.folders[this.selectedFolder]) {
        return undefined
      }
      return this.folders[this.selectedFolder].type
    },
    modalTitle (): string {
      let newAssetGroupType = this.newAssetGroupType

      switch (this.newAssetGroupType) {
        case 'tweetpoll':
          newAssetGroupType = 'Twitter poll'
          break
        case 'ig_hashtag':
          newAssetGroupType = 'Instagram hashtag'
          break
        case 'hashtag':
          newAssetGroupType = 'Twitter hashtag'
          break
        case 'handle':
          newAssetGroupType = 'Twitter handle'
          break
        case 'widget':
          newAssetGroupType = 'Widget'
          break
        case 'fb_chat':
          newAssetGroupType = 'Facebook Live chat'
          break
        case 'yt_chat':
          newAssetGroupType = 'YouTube Live chat'
          break
      }

      return 'Add new ' + newAssetGroupType
    },
    teamRole (): string {
      try {
        for (const team in this.allTeams) {
          if (this.allTeams[team].id === this.teamId) {
            return this.allTeams[team].members[this.userId].role
          }
        }
      } catch (error) {}
      return 'unknown'
    }
  },
  watch: {
    async tweetSelectorVisible (newVal: boolean) {
      if(newVal) {
        // the watch is called too soon, and the input is undefined
        // so we wait a bit: (TODO is there a better place to do this?)
        await this.$nextTick()
        this.setFocus('tweetSelectorInput')
      }
    }
  },
  data: () => ({
    starFilter: 'all',
    sortFilter: 'name',
    submitStatus: '',
    typeFilter: '',
    tweetSelectorVisible: false,
    instagramSelectorVisible: false,
    newVisible: false,
    newAssetGroupType: '',
    newAssetGroupName: '',
    newAssetURL: '',
    popupVisible: false,
    assetTypeSelectorVisible: false,
    sortOptions: [
      { name: 'Name', value: 'name' },
      { name: 'Stars', value: 'stars' },
      { name: 'Date', value: 'date' }
    ],
    assetTypes: [
      { name: 'All', value: '' },
      { name: 'Backgrounds', value: 'background' },
      { name: 'Slates', value: 'slate' },
      { name: 'Clips', value: 'video' }
    ],
    starFilters: [
      { name: 'All', value: 0 },
      { name: '5 Stars', value: 5 },
      { name: '4+ Stars', value: 4 },
      { name: '3+ Stars', value: 3 },
      { name: '2+ Stars', value: 2 },
      { name: '1+ Stars', value: 1 }
    ]
  }),
  validations: {
    newAssetGroupName: {
      required,
      minLength: minLength(2),
      correct: text => ['@', '#'].indexOf(text[0]) === -1,
      cleanHashtag: cleanHashtag(),
      noDouble: inArray(),
      correctUrl: correctUrl()
    },
    newAssetURL: {
      required,
      correctUrl: text => text.startsWith('https://'),
      correctYTUrl: correctYTUrl(),
      correctIGUrl: correctIGUrl()
    }
  },
  methods: {
    setFocus (refName: string) {
        const input = this.$refs[refName] as HTMLElement | undefined
        if(input !== undefined) {
          input.focus()
        }
    },
    gotoParentFolder () {
      if (!this.activeFolder) return
      const folder = this.activeFolder as AssetGroup
      this.openFolder(folder.parent_id || '')
    },
    openModal (assetType) {
      this.newAssetGroupType = assetType
      this.newAssetGroupName = ''
      this.newAssetURL = ''
      this.submitStatus = ''
      this.$v.$reset()
      this.newVisible = true
      this.popupVisible = false
    },
    addNewTweet () {
      this.$v.$touch()
      if (!this.$v.newAssetURL) {
        return
      }

      if (this.$v.newAssetURL.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.submitStatus = 'submitting'
        this.tweetSelectorVisible = false
        this.createTweet(this.newAssetURL)
      }
    },
    addNewInstagramPost () {
      this.$v.$touch()
      if (!this.$v.newAssetURL) {
        return
      }

      if (this.$v.newAssetURL.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.submitStatus = 'submitting'
        this.instagramSelectorVisible = false
        this.createInstagramPost(this.newAssetURL)
      }
    },
    addNewAssetGroup () {
      if (!this.$v.newAssetGroupName) return
      this.$v.newAssetGroupName.$touch()
      if (this.$v.newAssetGroupName!.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        if (this.newAssetGroupType === 'widget' || this.newAssetGroupType === AssetGroupType.YouTubeChat || this.newAssetGroupType === AssetGroupType.FacebookChat) {
          if (!this.$v.newAssetURL) return
          this.$v.newAssetURL.$touch()
          if (this.$v.newAssetURL!.$invalid) {
            this.submitStatus = 'ERROR'
          } else {
            this.submitStatus = 'submitting'
            this.newVisible = false
            switch (this.newAssetGroupType) {
              case 'widget':
                this.$emit('addwidget', {
                  name: this.newAssetGroupName,
                  type: 'widget',
                  url: this.newAssetURL,
                  thumbnail: 'TODO'
                })
                break
              case AssetGroupType.FacebookChat:
              case AssetGroupType.YouTubeChat:
                this.createLiveChat()
                break
            }
          }
        } else {
          this.submitStatus = 'submitting'
          this.newVisible = false
          switch (this.newAssetGroupType) {
            case AssetGroupType.Folder:
              this.createFolder(this.newAssetGroupName)
              break
            case AssetGroupType.TwitterHashtag:
              this.createHashtag(this.newAssetGroupName)
              break
            case AssetGroupType.TwitterHandle:
              this.createHandle(this.newAssetGroupName)
              break
            case AssetGroupType.TwitterPoll:
              this.createPoll(this.newAssetGroupName)
              break
            case AssetGroupType.InstagramHashtag:
              this.createInstagramHashtag(this.newAssetGroupName)
              break
          }
        }
      }
    },
    updateStars () {
      this.$emit('filterStars', this.starFilter)
    },
    createFolder (folder) {
      this.$emit('createFolder', folder)
    },
    createHandle (folder) {
      this.$emit('createHandle', folder)
    },
    createHashtag (folder) {
      this.$emit('createHashtag', folder)
    },
    createInstagramHashtag (folder) {
      this.$emit('createInstagramHashtag', folder)
    },
    createLiveChat () {
      this.$emit('createLiveChat', { name: this.newAssetGroupName, url: this.newAssetURL, type: this.newAssetGroupType })
    },
    createPoll (url) {
      const cleanurl = url.split('?')[0]
      this.$emit('createPoll', cleanurl)
    },
    createTweet (url) {
      this.$emit('createTweet', url)
    },
    createInstagramPost (url) {
      this.$emit('createInstagramPost', url)
    },
    openFolder (folder: AssetGroup | string) {
      this.$emit('openFolder', folder)
    },
    updateAsset (asset) {
      this.$emit('updateAsset', asset)
    },
    deleteFolder (folder) {
      this.$emit('deleteFolder', folder)
    },
    fileUploaded (file) {
      this.$emit('fileUploaded', file)
    },
    addwidget (widget) {
      this.$emit('addwidget', widget)
    },
    showFolderImport () {
      this.$emit('showFolderImport')
    },
    showTweetSelector () {
      this.$v.$reset()
      this.newAssetGroupName = ''
      this.newAssetURL = ''
      this.submitStatus = ''
      this.newAssetGroupType = AssetGroupType.Tweet
      this.tweetSelectorVisible = true
    },
    showInstagramSelector () {
      this.$v.$reset()
      this.newAssetGroupName = ''
      this.newAssetURL = ''
      this.submitStatus = ''
      this.newAssetGroupType = AssetGroupType.InstagramHashtag
      this.instagramSelectorVisible = true
    },
    showAssetTypeSelector () {
      // rootFolder = empty id, can only create folders at this level
      if (!this.selectedFolder) {
        this.openModal('folder')
        return
      }
      this.assetTypeSelectorVisible = true
    },
    hideAssetTypeSelector () {
      this.assetTypeSelectorVisible = false
    },
    getFolder (folderid: string): AssetGroup | undefined {
      return this.allFolders[folderid]
    }
  },
  components: {
    FolderTree,
    FileSpace,
    AssetTypeModal,
    Modal,
    'clip-loader': ClipLoader,
    'el-select': Select,
    'el-option': Option,
  }
})
